import { descriptions } from "@/Config/Export/CreateNewJob/ProductDeclarationSchema";
import { ImportInvoiceDescription } from "@/Config/ImportJob/CreateNewJob/Invoice/InvoiceDeclarationSchema";

export const FieldDynamicRules = [
  {
    form: "SEZForm",
    target: "sezUnitCode",
    dependsOn: "general.exportSBType",
    property: "visible",
    condition: (value) => value !== "sez_exbond",
  },
  {
    form: "SEZForm",
    target: "drawbackBeneficiary",
    dependsOn: "general.exportSBType",
    property: "visible",
    condition: (value) => value === "sez_dta",
  },
  {
    form: "invoiceBuyer",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportInvoiceBuyerAddress",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportInvoiceBuyerCity",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportInvoiceBuyerPincode",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportInvoiceBuyerCountry",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportInvoiceBuyerState",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportInvoiceNumber",
    target: "eSanchitInvsrNo",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "importSezForm",
    target: "importSourceOfImport",
    dependsOn: "importSubmissionType",
    property: "visible",
    condition: (value) => value == "bill",
  },
  {
    form: "importSezForm",
    target: "importDestination",
    dependsOn: "importSubmissionType",
    property: "visible",
    condition: (value) => value !== "bill",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentNatureOfCargo",
    dependsOn: "general.exportTransportMode",
    property: "disabled",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentAirlineCode",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentAirline",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentFlightNumber",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentFlightDate",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentMawbNo",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentMawbDate",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentHawbNo",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentHawbDate",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentPkgsInMawb",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value === "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentShiplineCode",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentShippingLine",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentVesselName",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentSailingDate",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentVoyogeNumber",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentMblNo",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentMblDate",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentHblNo",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentHblDate",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentMain",
    target: "shipmentNoOfContainer",
    dependsOn: "general.exportTransportMode",
    property: "visible",
    condition: (value) => value !== "air",
  },
  {
    form: "exportShipmentStuffingDetails",
    target: "exportShipmentStuffingCFS",
    dependsOn: "exportShipmentStuffingGoodsStuffedAt",
    property: "visible",
    condition: (value) => value !== "Factory",
  },
  {
    form: "exportShipmentStuffingDetails",
    target: "exportShipmentStuffingFactoryAddress",
    dependsOn: "exportShipmentStuffingGoodsStuffedAt",
    property: "disabled",
    condition: (value) => value !== "Factory",
  },
  {
    form: "importProductProductionDetails",
    target: "importProductBestBeforeDate",
    dependsOn: "importProductManufacuturerDate",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "importProductProductionDetails",
    target: "importProductBestBeforeDate",
    dependsOn: "importProductExpiryDate",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportProductProductionDetails",
    target: "exportProductBestBeforeDate",
    dependsOn: "exportProductManufacuturerDate",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "exportProductProductionDetails",
    target: "exportProductBestBeforeDate",
    dependsOn: "exportProductExpiryDate",
    property: "disabled",
    condition: (value) => !value,
  },
  {
    form: "importProductMain",
    target: "importInvoiceCurrency",
    dependsOn: "invoiceMain.importCurrency.name",
    property: "setValue",
    condition: (depVal) => depVal, // or transformation
  },
  {
    form: "importProductMain",
    target: "exportInvoiceCurrency",
    dependsOn: "invoiceMain.exportCurrency.name",
    property: "setValue",
    condition: (depVal) => depVal, // or transformation
  },
  {
    form: "productReExport",
    target: "exportProductReExportQuantityExporterValue",
    dependsOn: "productMain.exportProductMainQuantity",
    property: "setValue",
    condition: (depVal) => depVal, // or transformation
  },

  {
    form: "entityForm",
    target: "exportEntityType",
    dependsOn: "entity",
    property: "setOptions",
    condition: (depVal) => {
      const list = Array.isArray(depVal) ? depVal : [depVal];
      const existingTypes = list.map((e) => e.exportEntityType);
      return [
        {
          label: "Customer",
          value: "Customer",
          disabled: existingTypes.includes("Customer"),
        },
        {
          label: "Transporter",
          value: "Transporter",
        },
        {
          label: "Forwarding Agent",
          value: "Forwarding Agent",
          disabled: existingTypes.includes("Forwarding Agent"),
        },
      ];
    },
  },
  {
    form: "bankdealer",
    target: "customeBankDealerEntityName",
    dependsOn: "bankdealer",
    property: "setValue",
    condition: (depVal) => {
      // depVal is an array → take first object's name
      const currentName = depVal?.[0]?.customeBankDealerEntityName || "Bank-0";

      // Split using hyphen
      const parts = currentName.split("-");

      // Extract the number part safely
      const currentNumber = parts.length > 1 ? parseInt(parts[1]) : 0;

      // Increment the number
      const nextNumber = currentNumber + 1;

      // Generate the next bank name
      const nextBankName = `Bank-${nextNumber}`;

      console.log("Current:", currentName);
      console.log("Next:", nextBankName);

      return nextBankName;
    },
  },
  {
    form: "importProductMain",
    target: "declarationRemarks",
    dependsOn: "declarationCode",
    property: "setValue",
    overRide: true, // 👈 ADD THIS
    condition: (depVal) => {
      if (depVal === "DB001-DBK Declaration - No IGST ITC availed") {
        return descriptions[1];
      } else if (depVal === "DB002-DBK Declaration - No IGST Refund claimed") {
        return descriptions[2];
      } else if (
        depVal === "DB003-DBK Declaration - No CENVAT credit carry forward"
      ) {
        return descriptions[3];
      } else if (depVal === "RD001 - RODTEP Declaration") {
        return descriptions[0];
      } else if (depVal === "R5001 - ROSCTL Declaration") {
        return descriptions[4];
      }
    },
  },
  {
    form: "importProductMain",
    target: "declarationType",
    dependsOn: "declarationType",
    property: "setValue",
    condition: (depVal) => {
      if (depVal === undefined) {
        return "Declaration";
      }
    },
  },

  {
    form: "importProductMain",
    target: "exportAdditionalinfoCode",
    dependsOn: "exportAdditionalinfoQualifier",
    property: "setQueryParams",
    condition: (depVal) => ({
      type: depVal,
    }),
  },
  {
    form: "exportProductMain",
    target: "declarationRemarks",
    dependsOn: "declarationCode",
    property: "setValue",
    overRide: true,
    condition: (depVal) => {
      if (depVal === "" || depVal === null || depVal === undefined) {
        return " ";
      }
    },
  },
  {
    form: "exportProductMain",
    target: "exportProductMainDescription",
    dependsOn: "isDescription",
    property: "visible",
    condition: (value) => {
      console.log(value, "value");
      return value !== true;
    },
  },
  {
    form: "exportProductMain",
    target: "exportProductMainDescriptionId",
    dependsOn: "isDescription",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
  {
    form: "importProductMain",
    target: "importProductMainDescription",
    dependsOn: "isDescription",
    property: "visible",
    condition: (value) => {
      console.log(value, "value");
      return value !== true;
    },
  },
  {
    form: "importProductMain",
    target: "importProductMainDescriptionId",
    dependsOn: "isDescription",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
  {
    form: "InvoiceOtherCharges",
    target: "Freightrate",
    dependsOn: "invoiceMain.importInvoiceTOI", // ✅ CORRECT PATH
    property: "setValue",
    condition: (depVal) => {
      if (depVal === "FOB") return 20;
      // if () return 20;
      return undefined;
    },
  },
  {
    form: "InvoiceOtherCharges",
    target: "Freightrate",
    dependsOn: "invoiceMain.importInvoiceTOI",
    property: "disabled",
    condition: (depVal) => {
      // ✅ Enable for FOB and C&F
      if (depVal === "FOB" || depVal === "C&I") {
        return false; // not disabled
      }
      return true;
    },
  },

  {
    form: "InvoiceOtherCharges",
    target: "Insurancerate",
    dependsOn: "invoiceMain.importInvoiceTOI",
    property: "disabled",
    condition: (depVal) => {
      // ✅ Enable for FOB and C&F
      if (depVal === "FOB" || depVal === "C&F") {
        return false; // not disabled
      }
      return true;
    },
  },
  {
    form: "InvoiceOtherCharges",
    target: "Insurancerate",
    dependsOn: "invoiceMain.importInvoiceTOI",
    property: "setValue",
    condition: (depVal) => {
      if (depVal === "FOB") return 1.125; // ✅ FOB → 1.125
      if (depVal === "CIF") return 0.0; // ✅ CIF → 0.00
      if (depVal === "C&F") return 1.125; // ✅ C&F → 1.125
      return undefined; // ✅ Others → No change
    },
  },
  {
    target: "Freightamount",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "invoiceMain.importInvoiceTOI",
    ],
    formula: ({
      "invoiceMain.totalProductValue": totalProductValue,
      "invoiceMain.importInvoiceTOI": importInvoiceTOI,
    }) => {
      // ✅ ONLY RUN WHEN FOB
      if (importInvoiceTOI !== "FOB") return 0;

      if (!totalProductValue) return 0;

      const amount = (Number(totalProductValue) * Number(20)) / 100;

      return Number(amount.toFixed(2)); // ✅ 2 decimal
    },
  },
  {
    target: "Freightamount",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "invoiceMain.importInvoiceTOI",
    ],
    formula: ({
      "invoiceMain.totalProductValue": totalProductValue,
      "invoiceMain.importInvoiceTOI": importInvoiceTOI,
    }) => {
      // ✅ ONLY RUN WHEN FOB
      if (importInvoiceTOI !== "C&I") return 0;

      if (!totalProductValue) return 0;

      const amount = (Number(totalProductValue) * Number(20)) / 100;

      return Number(amount.toFixed(2)); // ✅ 2 decimal
    },
  },

  {
    target: "Insuranceamoud",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "invoiceMain.importInvoiceTOI",
    ],
    formula: ({
      "invoiceMain.totalProductValue": totalProductValue,
      "invoiceMain.importInvoiceTOI": importInvoiceTOI,
    }) => {
      // ✅ ONLY RUN WHEN FOB
      if (importInvoiceTOI !== "FOB") return 0;

      if (!totalProductValue) return 0;

      const amount = (Number(totalProductValue) * Number(1.125)) / 100;

      return Number(amount.toFixed(2));
    },
  },
  {
    target: "Insuranceamoud",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "invoiceMain.importInvoiceTOI",
    ],
    formula: ({
      "invoiceMain.totalProductValue": totalProductValue,
      "invoiceMain.importInvoiceTOI": importInvoiceTOI,
    }) => {
      // ✅ ONLY RUN WHEN FOB
      if (importInvoiceTOI !== "C&F") return 0;

      if (!totalProductValue) return 0;

      const amount = (Number(totalProductValue) * Number(1.125)) / 100;

      return Number(amount.toFixed(2));
    },
  },
  {
    form: "exportProductMain",
    target: "exportProductGeneralCalcMethod",
    dependsOn: "exportProductGeneralCalcMethod",
    property: "setValue",
    overRide: true,
    condition: (depVal) => {
      if (depVal === "" || depVal === null || depVal === undefined) {
        return "%age";
      }
    },
  },
  {
    form: "exportProductMain",
    target: "exportProductGeneralCalcAmount",
    dependsOn: "exportProductGeneralCalcAmount",
    property: "setValue",
    overRide: true,
    condition: (depVal) => {
      if (depVal === "" || depVal === null || depVal === undefined) {
        return 110;
      }
    },
  },
  {
    form: "exportProductGeneral",
    target: "exportProductGeneralPMVPerUnit",
    dependsOn: [
      "exportProductGeneralCalcMethod",
      "invoiceMain.exportInvoiceTOI",
      "productMain.exportProductMainUnitPrice",
      "productMain.exportProductMainQuantity",
      "invoiceMain.currencyValue",
    ],
    property: "setValue",
    overRide: true,
    condition: (depVal) => {
      const {
        exportProductGeneralCalcMethod,
        exportInvoiceTOI,
        exportProductMainUnitPrice,
        currencyValue,
      } = depVal;
      if (exportProductGeneralCalcMethod === "%age") {
        if (exportInvoiceTOI === "FOB") {
          const PMVPerUnit =
            exportProductMainUnitPrice * currencyValue * (10 / 100) +
            exportProductMainUnitPrice * currencyValue;
          return Number(PMVPerUnit.toFixed(2));
        }
        // else if(exportInvoiceTOI === "FOB"){
        //   console.log("FOB");
        //   const PMVPerUnit =((((exportInvoiceproductvalue)*currencyValue)*(10/100)) + (exportInvoiceproductvalue*currencyValue));
        //   return PMVPerUnit;
        // }
      }
    },
  },
  {
    form: "exportProductGeneral",
    target: "exportProductGeneralTotalPMV",
    dependsOn: [
      "exportProductGeneralCalcMethod",
      "invoiceMain.exportInvoiceTOI",
      "productMain.exportProductMainAmount",
      "invoiceMain.currencyValue",
    ],
    property: "setValue",
    overRide: true,
    condition: ({
      exportProductGeneralCalcMethod,
      exportInvoiceTOI,
      exportProductMainAmount,
      currencyValue,
    }) => {
      if (exportProductGeneralCalcMethod === "%age") {
        if (exportInvoiceTOI === "FOB") {
          const PMVPerUnit =
            exportProductMainAmount * currencyValue * (10 / 100) +
            exportProductMainAmount * currencyValue;
          return Number(PMVPerUnit.toFixed(2));
        }
      }
    },
  },
  {
    form: "importProductMain",
    target: "declarationRemarks",
    dependsOn: "declarationCode",
    property: "setValue",
    overRide: true,
    condition: (depVal) => {
      if (depVal === "CUV01 - Valuation Declaration - I") {
        return ImportInvoiceDescription[0];
      } else if (depVal === "CUV02 - Valuation Declaration - II") {
        return ImportInvoiceDescription[1];
      } else if (depVal === "CUV03 - Valuation Declaration - III") {
        return ImportInvoiceDescription[2];
      } else if (depVal === "CUV04 - Related Party Declaration") {
        return ImportInvoiceDescription[3];
      } else if (depVal === "CUV05 - Related Party Declaration") {
        return ImportInvoiceDescription[4];
      }
    },
  },
  {
    form: "productOtherDuty",
    target: "otherDutyDumpDuty",
    dependsOn: "otherDutyDumpCalcMethod",
    property: "disabled",
    condition: (depVal) => {
      const allowed = [
        "ageofAssblalue",
        "ageofLandedValue",
        "ageofCIF",
        "ofLandedlessCCVD",
      ];

      return !allowed.includes(depVal);
    },
  },
  {
    form: "productOtherDuty",
    target: "otherDutyDumpCurrency",
    dependsOn: "otherDutyDumpCalcMethod",
    property: "disabled",
    condition: (depVal) => {
      const allowed = ["SpecificonQty", "DifferenceoflandedSpecific"];

      return !allowed.includes(depVal);
    },
  },
  {
    form: "productOtherDuty",
    target: "otherDutyQuantityPrice",
    dependsOn: "otherDutyDumpCalcMethod",
    property: "disabled",
    condition: (depVal) => {
      const allowed = ["SpecificonQty", "DifferenceoflandedSpecific"];

      return !allowed.includes(depVal);
    },
  },
  {
    form: "productOtherDuty",
    target: "otherDutyDumpQuantityValue",
    dependsOn: "otherDutyDumpCalcMethod",
    property: "disabled",
    condition: (depVal) => {
      const allowed = ["SpecificonQty", "DifferenceoflandedSpecific"];

      return !allowed.includes(depVal);
    },
  },
  {
    form: "exportInvoiceMain",
    target: "BuyerInfo",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
   {
    form: "exportInvoiceMain",
    target: "buyerName",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      console.log(value, "value");
      return value === true;
    },
  },
   {
    form: "exportInvoiceMain",
    target: "exportInvoiceBuyerAddress",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
   {
    form: "exportInvoiceMain",
    target: "exportInvoiceBuyerCity",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
   {
    form: "exportInvoiceMain",
    target: "exportInvoiceBuyerPincode",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
   {
    form: "exportInvoiceMain",
    target: "exportInvoiceBuyerCountry",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
   {
    form: "exportInvoiceMain",
    target: "exportInvoiceBuyerState",
    dependsOn: "general.isExportBuyerOtherthanConsignee",
    property: "visible",
    condition: (value) => {
      return value === true;
    },
  },
];
